import { connect } from 'react-redux';

import { clearInputError, setInputError } from '../actions/GenericActions';
import { checkOtp, sendOtp } from '../actions/OtcActions';
import OtpView from '../components/Steps/Otp/OtpView';

const mapStateToProps = state => ({
  contact: state.choice.selected,
  isLoading: state.generic.request.isLoading,
  otcError: state.otp.otcError,
  otc: state.otp.otc,
});

const mapDispatchToProps = dispatch => ({
  sendOtp: ({ contact, isRetry = true }) => dispatch(sendOtp({ contact, isRetry })),
  checkOtp: ({ otpCode }) => dispatch(checkOtp({ otpCode })),
  setInputError: ({ field, error }) => dispatch(setInputError({ field, error })),
  clearInputError: ({ field }) => dispatch(clearInputError({ field })),
});

export default connect(mapStateToProps, mapDispatchToProps)(OtpView);
